import { render, staticRenderFns } from "./group.vue?vue&type=template&id=e256794e&scoped=true"
import script from "./group.vue?vue&type=script&setup=true&lang=js"
export * from "./group.vue?vue&type=script&setup=true&lang=js"
import style0 from "./group.vue?vue&type=style&index=0&id=e256794e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e256794e",
  null
  
)

export default component.exports